import {seek, pause} from 'store/video/actions';
import {updateShareUrl, setVideoTitle} from 'store/config/actions';
import {openShareWindow} from 'share';
import {triggerTranscriptDownload, triggerCaptionDownload, triggerTranscriptPrint} from 'export';

export const ActionTypes = {
    SET_WIDTH: 'SET_WIDTH',

    TOGGLE_ENTITY_MENU: 'TOGGLE_ENTITY_MENU',
    CLOSE_ENTITY_MENU: 'CLOSE_ENTITY_MENU',
    TOGGLE_ENTITY_TYPE: 'TOGGLE_ENTITY_TYPE',

    SHOW_HEATMAP_TOOLTIP: 'SHOW_HEATMAP_TOOLTIP',
    HIDE_HEATMAP_TOOLTIP: 'HIDE_HEATMAP_TOOLTIP',
    EXPAND_HEATMAP_TOOLTIP: 'EXPAND_HEATMAP_TOOLTIP',

    SEEK_TO_HEATMAP_BLOCK: 'SEEK_TO_HEATMAP_BLOCK',

    DISABLE_AUTOSCROLL: 'DISABLE_AUTOSCROLL',
    RESUME_AUTOSCROLL: 'RESUME_AUTOSCROLL',

    TOGGLE_SETTINGS_DIALOG: 'TOGGLE_SETTINGS_DIALOG',

    TOGGLE_SHARE_DIALOG: 'TOGGLE_SHARE_DIALOG',
    SHARE: 'SHARE',

    DOWNLOAD_TRANSCRIPT: 'DOWNLOAD_TRANSCRIPT',
    SET_TRANSCRIPT_FORMAT: 'SET_TRANSCRIPT_FORMAT',
    TOGGLE_DOWNLOAD_DIALOG: 'TOGGLE_DOWNLOAD_DIALOG',
    TOGGLE_DOWNLOAD_LOADING: 'TOGGLE_DOWNLOAD_LOADING',

    DOWNLOAD_CAPTIONS: 'DOWNLOAD_CAPTIONS',
    SET_CAPTION_FORMAT: 'SET_CAPTION_FORMAT',
    SET_CAPTION_FORMATS: 'SET_CAPTION_FORMATS',

    PRINT_TRANSCRIPT: 'PRINT_TRANSCRIPT',
    TOGGLE_PRINT_LOADING: 'TOGGLE_PRINT_LOADING',
};

export const setWidth = (width) => ({
    type: ActionTypes.SET_WIDTH,
    width,
});

export const toggleEntityMenu = () => ({
    type: ActionTypes.TOGGLE_ENTITY_MENU,
});

export const closeEntityMenu = () => ({
    type: ActionTypes.CLOSE_ENTITY_MENU,
});

export const toggleEntityType = (entityType) => ({
    type: ActionTypes.TOGGLE_ENTITY_TYPE,
    entityType,
});

export const togglePrintLoading = () => ({
    type: ActionTypes.TOGGLE_PRINT_LOADING,
});

export const toggleDownloadLoading = () => ({
    type: ActionTypes.TOGGLE_DOWNLOAD_LOADING,
});

export const showHeatmapTooltip = (block) => ({
    type: ActionTypes.SHOW_HEATMAP_TOOLTIP,
    block,
});

export const hideHeatmapTooltip = (block) => ({
    type: ActionTypes.HIDE_HEATMAP_TOOLTIP,
    block,
});

export const expandHeatmapTooltip = (block) => ({
    type: ActionTypes.EXPAND_HEATMAP_TOOLTIP,
    block,
});

export const seekToHeatmapBlock = (block) => (dispatch) => {
    dispatch({type: ActionTypes.SEEK_TO_HEATMAP_BLOCK, block});
    dispatch(seek(block.get('startTime')));
};

export const disableAutoscroll = () => ({
    type: ActionTypes.DISABLE_AUTOSCROLL,
});

export const resumeAutoscroll = () => ({
    type: ActionTypes.RESUME_AUTOSCROLL,
});

let dialogTimeoutId;
export const dialogDelay = 300;

const toggleDialog = dialog => (dispatch, getState) => {
    const state = getState();
    const actions = {
        share: ActionTypes.TOGGLE_SHARE_DIALOG,
        download: ActionTypes.TOGGLE_DOWNLOAD_DIALOG,
        settings: ActionTypes.TOGGLE_SETTINGS_DIALOG,
    };
    const getUIKey = key => `${key}Opened`;

    return new Promise(resolve => {
        const callback = () => {
            dispatch({type: actions[dialog]});
            if (dialog === 'share' && getState().ui.get(getUIKey(dialog))) dispatch(updateShareUrl());
            resolve();
        };

        clearTimeout(dialogTimeoutId);

        const opened = Object.keys(actions)
            .filter(key => key !== dialog)
            .find(key => state.ui.get(getUIKey(key)));

        if (opened) {
            dispatch({type: actions[opened]});
            dialogTimeoutId = setTimeout(callback, exports.dialogDelay);
        } else {
            dispatch(pause());
            callback();
        }
    });
};

export const toggleSettings = () => toggleDialog('settings');
export const toggleShare = () => toggleDialog('share');
export const toggleDownload = () => toggleDialog('download');

export const share = (service) => (dispatch, getState) => {
    dispatch({type: ActionTypes.SHARE, service});
    openShareWindow(service, getState().config.get('shareUrl'));
};

export const setTranscriptFormat = format => ({
    type: ActionTypes.SET_TRANSCRIPT_FORMAT,
    format,
});

const getVideoTitle = async (dispatch, getState, adapter, toggleAction) => {
    const state = getState();

    let videoTitle = state.config.get('videoTitle');

    if (!videoTitle) {
        dispatch(toggleAction());
        videoTitle = await adapter.getVideoTitle();
        dispatch(setVideoTitle(videoTitle));
        dispatch(toggleAction());
    }

    return videoTitle;
};

export const downloadTranscript = () => async (dispatch, getState, adapter) => {
    dispatch({type: ActionTypes.DOWNLOAD_TRANSCRIPT});
    const state = getState();
    const format = state.ui.get('downloadTranscriptFormat');
    const videoTitle = await getVideoTitle(dispatch, getState, adapter, toggleDownloadLoading);
    triggerTranscriptDownload(state.elementList, format, videoTitle);
};

export const setCaptionFormats = (language, captions) => ({
    type: ActionTypes.SET_CAPTION_FORMATS,
    language,
    captions,
});

export const setCaptionFormat = format => ({
    type: ActionTypes.SET_CAPTION_FORMAT,
    format,
});

export const downloadCaptions = () => async (dispatch, getState, adapter) => {
    dispatch({type: ActionTypes.DOWNLOAD_CAPTIONS});

    const state = getState();

    const format = state.ui.get('downloadCaptionFormat');
    const language = state.config.get('language');
    const caption = state.captions
        .get('urls')
        .get(language)
        .find(c => c.get('format') === format);

    if (!caption) return;

    const videoTitle = await getVideoTitle(dispatch, getState, adapter, toggleDownloadLoading);
    triggerCaptionDownload(caption, videoTitle);
};

export const printTranscript = () => async (dispatch, getState, adapter) => {
    dispatch({type: ActionTypes.PRINT_TRANSCRIPT});
    const state = getState();
    const videoTitle = await getVideoTitle(dispatch, getState, adapter, togglePrintLoading);
    triggerTranscriptPrint(state.elementList, {videoTitle, rtl: state.config.get('rtl')});
};



// WEBPACK FOOTER //
// ./scripts/store/ui/actions.js